import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Volume2, Loader2, Pause } from "lucide-react";
import { toast } from "sonner";

export function ReadAloudButton({ text, voice, testid = "read-aloud", label = "Read aloud", tone = "#81B29A" }) {
  const [state, setState] = useState("idle"); // idle | loading | playing
  const audioRef = useRef(null);
  const effectiveVoice = voice || localStorage.getItem("rfa_voice") || "fable";

  const toggle = async () => {
    if (state === "playing") { audioRef.current?.pause(); setState("idle"); return; }
    if (audioRef.current) { audioRef.current.play(); setState("playing"); return; }
    setState("loading");
    try {
      const { data } = await api.post("/tts", { text, voice: effectiveVoice });
      const audio = new Audio(`data:audio/mp3;base64,${data.audio_base64}`);
      audio.onended = () => setState("idle");
      audio.onpause = () => setState((s) => (s === "playing" ? "idle" : s));
      audioRef.current = audio;
      await audio.play();
      setState("playing");
    } catch (e) {
      toast.error("Couldn't read that aloud. Try again.");
      setState("idle");
    }
  };

  return (
    <button data-testid={testid} onClick={toggle}
      className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-colors hover:text-white"
      style={{ borderColor: tone, color: state === "playing" ? "#fff" : tone, background: state === "playing" ? tone : "transparent" }}>
      {state === "loading" ? <Loader2 size={15} className="animate-spin" /> : state === "playing" ? <Pause size={15} /> : <Volume2 size={15} />}
      {state === "playing" ? "Pause" : state === "loading" ? "Loading…" : label}
    </button>
  );
}
